"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveStrategy;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _invariant = _interopRequireDefault(require("invariant"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _ensureStrategy3 = _interopRequireDefault(require("./ensureStrategy"));

function resolveStrategy(ctx, strategyType, strategy) {
  var strategies = ctx.strategies;

  var _ensureStrategy = (0, _ensureStrategy3.default)(strategy),
      _ensureStrategy2 = (0, _slicedToArray2.default)(_ensureStrategy, 2),
      strategyIdent = _ensureStrategy2[0],
      strategyArgs = _ensureStrategy2[1];

  var handler = strategies[strategyType][strategyIdent];
  (0, _invariant.default)((0, _isFunction.default)(handler), "Strategy ".concat(strategy, " of type ").concat(strategyType, " not found or handler is not a function."));
  return [handler, strategyArgs];
}